import { MAT_DATE_FORMATS } from "@angular/material/core";

/**
 * Gloabally Change Dateformat for Microservices
 */
export const SIMPLE_FORMAT = {
    parse: {
        dateInput: 'MM/DD/YYYY',
    },
    display: {
        dateInput: 'MM/DD/YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'L',
        monthYearA11yLabel: 'YYYY',
    },
};

/**
 * Providers array which can be imported and used across the application
 */
export const DATE_FORMAT_PROVIDERS = [
    { provide: MAT_DATE_FORMATS, useValue: SIMPLE_FORMAT }
];

